// extracted by mini-css-extract-plugin
module.exports = {"label":"DateRange__label___doIMl","termInputLabel":"DateRange__termInputLabel___1sXGk","calendar_container":"DateRange__calendar_container___paHtE"};